const firebaseConfig = {
    apiKey: "AIzaSyDTH8NSSQPKMZ1rtyiIPGRF4D0obL0QyI4",
    authDomain: "assignment-12-client.firebaseapp.com",
    projectId: "assignment-12-client",
    storageBucket: "assignment-12-client.appspot.com",
    messagingSenderId: "965239118644",
    appId: "1:965239118644:web:eccc8c697f33ebf8692361"
  };
  
  export default firebaseConfig;